/** Set from the server's checked tool response, never from browser storage. */
let active = false;
export function setPreviewMode(value: boolean): void { active = value; }
export function isPreview(): boolean { return active; }
